import React from 'react';
import { ICusProductListViewProps } from '../cus-product-list.data';

interface SeoSectionProps {
    props: ICusProductListViewProps;
}

export default function SeoSection({ props }: SeoSectionProps) {
    const categoryProducts = props.data.categoryProducts.result;
    const seoTitle = categoryProducts?.seoTitle;
    const seoText = categoryProducts?.seoText;

    if (!seoTitle && !seoText) {
        return null;
    }

    return (
        <section className='bs-product-list__seo'>
            {seoTitle && <h2 className='bs-product-list__seo__title'>{seoTitle}</h2>}
            {seoText && <div className='bs-product-list__seo__text' dangerouslySetInnerHTML={{ __html: seoText }} />}
        </section>
    );
}
